import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-signature-config-view',
  standalone: true,
  templateUrl: './signature-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignatureConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
